import { Plus, Scale, Search } from "lucide-react";

interface CauseListHeaderProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  onAddCase: () => void;
}

const CauseListHeader = ({
  searchTerm,
  onSearchTermChange,
  onAddCase,
}: CauseListHeaderProps) => {
  return (
    <div className="md:flex items-center justify-between gap-4">
      <div className="flex items-center gap-3 md:mb-0 mb-3">
        <div className="bg-white rounded-full p-3 shadow-sm">
          <Scale className="h-6 w-6 text-blue-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Cause List</h1>
      </div>
      <div className="flex flex-col md:flex-row items-stretch md:items-center gap-3 w-full md:w-auto">
        <div className="relative w-full md:w-64">
          <input
            type="text"
            placeholder="Search cases..."
            value={searchTerm}
            onChange={(event) => onSearchTermChange(event.target.value)}
            className="w-full px-4 py-2.5 pl-10 bg-white rounded-lg focus:ring-2 focus:ring-blue-500 outline-none shadow-sm"
          />
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
        </div>

        <button
          onClick={onAddCase}
          className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg font-medium md:mt-0 mt-2 flex items-center justify-center gap-2 shadow-sm"
        >
          <Plus className="w-5 h-5" />
          Add Case
        </button>
      </div>
    </div>
  );
};

export default CauseListHeader;
